const servicesPricing = {
    'Clinic Services': {
        'Chiropractic': [
            {
                label:       'Chiropractic Visit - Initial',
                slug:        'chiropractic-visit-initial',
                duration:    '60 min',
                cost:        '$125',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/discipline/1/treatment/7',
                description: 'Initial visit includes patient history, physical exam and assessment, diagnosis, and treament',
                highlighted: false,
            },
            {
                label:       'Chiropractic Visit - Subsequent',
                slug:        'chiropractic-visit-subsequent',
                duration:    '20-30 min',
                cost:        '$70',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/discipline/1/treatment/2',
                description: 'Visit may include any combination of the following: chiropractic adjustment, joint mobilization,  active release technique, soft tissue therapy, modalities, rehabilitation exercise.<div class="text-tiny decent-margin--top highlight">* As of January 2018, we have made a modest price increase to the pricing of Subsequent Chiropracitc visits to stay consistent with all new services being offered at the clinic.</div>',
                addOns: [
                    {label: 'Medical Acupuncture', cost: '+ $10'},
                    {label: 'Athletic Taping', cost: '+ $5-10'},
                ],
                highlighted: false,
            },
            {
                label:       'Chiropractic Visit - Extended Subsequent',
                slug:        'chiropractic-visit-extended-subsequent',
                duration:    '40 min',
                cost:        '$90',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/discipline/1/treatment/3',
                description: 'Longer visit may be required for more complex conditions, addressing multiple complaints, or more extensive rehabilitation exercise. Visit may include any combination of the following: chiropractic adjustment, active release technique, soft tissue therapy, modalities, rehabilitation exercise.<div class="text-tiny decent-margin--top highlight">* As of January 2018, we have made a modest price increase to the pricing of Subsequent Chiropracitc visits to stay consistent with all new services being offered at the clinic.</div>',
                addOns: [
                    {label: 'Medical Acupuncture', cost: '+ $10'},
                    {label: 'Athletic Taping', cost: '+ $5-10'},
                ],
                highlighted: false,
            },
            {
                label:       'Combined Chiropractic &amp; Pilates Rehabilitation',
                slug:        'combined-chiropractic-pilates-rehabilitation',
                duration:    '60 min',
                cost:        '$125',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/1/treatment/4',
                description: 'One hour personal training session includes targeted clinical Pilates training and rehabilitative exercise specific to patient need. Session may also encompass soft tissue massage, active release technique, joint mobilization, and chiropractic adjustments. **NOTE: first session will require patient history and thorough assessment to direct chiropractic rehabiliation',
                highlighted: false,
            },
        ],
        'Physiotherapy': [
            {
                label:       'Physiotherapy Visit - Initial',
                slug:        'physiotherapy-visit-initial',
                duration:    '60 min',
                cost:        '$125',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/18/treatment/37',
                description: 'Initial visit includes patient history, physical exam and assessment, diagnosis, and treament',
                highlighted: false,
            },
            {
                label:       'Physiotherapy Visit - Subsequent',
                slug:        'physiotherapy-visit-subsequent',
                duration:    '20-30 min',
                cost:        '$70',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/18/treatment/38',
                // description: 'Visit may include any combination of the following: chiropractic adjustment, joint mobilization,  active release technique, soft tissue therapy, modalities, rehabilitation exercise.',
                highlighted: false,
            },
            {
                label:       'Physiotherapy Visit - Extended Subsequent',
                slug:        'physiotherapy-visit-extended-subsequent',
                duration:    '40 min',
                cost:        '$90',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/18/treatment/39',
                // description: 'Longer visit may be required for more complex conditions, addressing multiple complaints, or more extensive rehabilitation exercise. Visit may include any combination of the following: chiropractic adjustment, active release technique, soft tissue therapy, modalities, rehabilitation exercise.',
                highlighted: false,
            },
        ],
        'Massage': [
            {
                label:       'Initial Assessment &amp; Treatment',
                slug:        'massage-visit-initial',
                duration:    '60 min',
                cost:        '$95',
                hst:         true,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/14',
                description: 'Initial visit includes a through postural and movement assessment and discussion regarding treatment goals prior to treatment. Treatment techniques include various soft tissue techniques: myofascial release and instrument assisted soft tissue. Treatment may also include corrective exercise and athletic taping.',
                highlighted: false,
            },
            {
                label:       'Massage Visit - Subsequent',
                slug:        'massage-visit-subsequent',
                duration:    '',
                cost:        '',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/14',
                description: '',
                addOns: [
                    {label: '30 Minute Massage', cost: '$60 + HST'},
                    {label: '45 Minute Massage', cost: '$75 + HST'},
                    {label: '60 Minute Massage', cost: '$95 + HST'},
                    {label: '90 Minute Massage', cost: '$130 + HST'},
                ],
                highlighted: false,
            },
        ],
        'Personal Training': [
            {
                label:       'Personal Training / Pilates Rehabilitation',
                slug:        'personal-training-pilates-rehabilitation',
                duration:    '60 min',
                cost:        '$100',
                hst:         true,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/1/treatment/5',
                description: '',
                highlighted: false,
            },
        ],
        'Acupuncture': [
            {
                label:       'Medical Acupuncture',
                slug:        'medical-acupuncture',
                duration:    '30 min',
                cost:        '$80',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/discipline/1/treatment/7',
                description: '',
                highlighted: false,
            },
        ],
        'Naturopath': [
            {
                label:       'Adult Initial Assessment',
                slug:        'naturopath-visit-initial-adult',
                duration:    '90 min',
                cost:        '$180',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/24',
                description: 'Initial intake includes a comprehensive Health History, Screening Physical Exam and Naturopathic Treatment Plan.',
                highlighted: false,
            },
            {
                label:       'Adult Naturopath Visit - Subsequent',
                slug:        'naturopath-visit-subsequent-adult',
                duration:    '30 min',
                cost:        '$90',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/26',
                description: 'Visit may address any combination of the following: New Health Concerns, Treatment Plan Concerns, Health Check-Ups, Naturopathic Recommendations including Health Counselling, Botanical Medicine, Clinical Nutrition, and Supplementation for Health Optimization.',
                highlighted: false,
            },
            {
                label:       'Adult Naturopath Visit - Extended Subsequent',
                slug:        'naturopath-visit-subsequent-adult-extended',
                duration:    '60 min',
                cost:        '$160',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/25',
                description: '',
                highlighted: false,
            },
            {
                label:       'Paediatric Initial Assessment',
                slug:        'naturopath-visit-initial-paediatric',
                duration:    '90 min',
                cost:        '$150',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/27',
                description: 'Initial intake includes a comprehensive Health History, Well-Child Check-Up, and Naturopathic Treatment Plan.',
                highlighted: false,
            },
            {
                label:       'Paediatric Naturopath Visit - Subsequent',
                slug:        'naturopath-visit-subsequent-paediatric',
                duration:    '30 min',
                cost:        '$80',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/29',
                description: 'Visit may address any combination of the following: New Health Concerns, Treatment Plan Concerns, Health Check-Ups, Naturopathic Recommendations including Health Counselling, Botanical Medicine, Clinical Nutrition, and Supplementation for Health Optimization.',
                highlighted: false,
            },
            {
                label:       'Paediatric Naturopath Visit - Extended Subsequent',
                slug:        'naturopath-visit-subsequent-paediatric-extended',
                duration:    '60 min',
                cost:        '$150',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/28',
                description: '',
                highlighted: false,
            },
            {
                label:       'Traditional Chinese Medicine Acupuncture Initial Assessment',
                slug:        'naturopath-visit-initial-tcm',
                duration:    '60 min',
                cost:        '$140',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/30',
                description: 'Initial intake includes a comprehensive Health History using concepts in Traditional Chinese Medicine and Health and Nutritional Recommendations.',
                highlighted: false,
            },
            {
                label:       'Traditional Chinese Medicine Acupuncture - Subsequent',
                slug:        'naturopath-visit-subsequent-tcm',
                duration:    '40 min',
                cost:        '$85',
                hst:         false,
                bookingLink: 'https://pursuithealth.janeapp.com/#/staff_member/16/treatment/31',
                description: '',
                highlighted: false,
            },
        ],
    },
    'Classes &amp; Memberships': {
        'Memberships': [
            {
                label:       'All The Perks Premium Membership',
                slug:        'membership-vip-auto-pay',
                duration:    '1 Month, Auto-Pay',
                cost:        '$168 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=40&prodId=100',
                bookingLabel: 'Buy Now',
                description: 'Includes <span class="lowlight">unlimited</span> PIH classes for the purchase month, 10% off all Clinic Services, 5% off retail products and discounted workshops offered at the clinic. This gives you the most bang for your buck. Requires a three (3) month commitment, after which 30 days cancellation notice is required. Monthly fee will be automatically charged according to the renewal schedule.',
                highlighted: true,
            },
            {
                label:       'Best Value Pursuit Studio Membership',
                slug:        'membership-unlimited-auto-pay',
                duration:    '1 Month, Auto-Pay',
                cost:        '$135 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=40&prodId=101',
                bookingLabel: 'Buy Now',
                description: 'Includes <span class="lowlight">unlimited</span> PIH classes for the purchase month. Requires a three (3) month commitment, after which 30 days cancellation notice is required. Monthly fee will be automatically charged according to the renewal schedule.',
                highlighted: false,
            },
            {
                label:       'Commitment Issues',
                slug:        'membership-unlimited-month-to-month',
                duration:    '1 Month',
                cost:        '$150 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100009',
                bookingLabel: 'Buy Now',
                description: 'Includes <span class="lowlight">unlimited</span> PIH classes for the purchase month. No contract required.',
                highlighted: false,
            },
            {
                label:       'Yearly',
                slug:        'membership-unlimited-auto-pay',
                duration:    '12 Months',
                cost:        '$1200 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100010',
                bookingLabel: 'Buy Now',
                description: 'Allows for unlimited classes for the whole year. No contract required.',
                highlighted: false,
            },
        ],
        'Classes': [
            {
                label:       'First Time\'s a Charm Intro Offer',
                slug:        'classes-intro',
                duration:    '10 Days',
                cost:        '$40 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100006',
                bookingLabel: 'Buy Now',
                description: 'Introductory offer to get your feet wet. Includes <span class="lowlight">unlimited</span> PIH classes for 10 days.',
                highlighted: true,
            },
            {
                label:       'Single Class / Drop-In',
                slug:        'classes-single',
                duration:    '',
                cost:        '$20 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100005',
                bookingLabel: 'Buy Now',
                description: '',
                highlighted: false,
            },
            {
                label:       '5 Class Pass',
                slug:        'classes-five',
                duration:    '',
                cost:        '$90 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100007',
                bookingLabel: 'Buy Now',
                description: 'Cost per class works out to $18/class. The classes are valid for three (3) months, any unused classes will not able to be redeemable.',
                highlighted: false,
            },
            {
                label:       '10 Class Pass',
                slug:        'classes-ten',
                duration:    '',
                cost:        '$170 + <span class="text-small">HST</span>',
                hst:         false,
                bookingLink: 'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=41&sTG=22&prodId=100008',
                bookingLabel: 'Buy Now',
                description: 'Cost per class works out to $17/class. The classes are valid for 10 months, any unused classes will not able to be redeemable.',
                highlighted: false,
            },
        ],
    }
};

export default servicesPricing;
